import { useEffect, useState } from 'react';
import { runtimeApi, type ModuleRecord } from '../../api/moduleruntime';

export function InstalledModulesPage() {
  const [installed, setInstalled] = useState<ModuleRecord[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void runtimeApi.listModules().then((r) => setInstalled(r.installed ?? [])).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Installed Modules</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        {installed.map((m) => (
          <div key={m.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
            <div className="flex items-start justify-between">
              <div>
                <h2 className="font-medium">{m.name}</h2>
                <p className="text-xs text-slate-500">{m.code} · v{m.version}</p>
              </div>
              <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs dark:bg-slate-800">{m.state}</span>
            </div>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">Health: {m.health_status?.status ?? 'unknown'}</p>
            <p className="mt-1 text-xs text-slate-500">Installed {new Date(m.installed_at).toLocaleString()}</p>
          </div>
        ))}
        {installed.length === 0 && <p className="text-sm text-slate-500">No modules installed yet.</p>}
      </div>
    </div>
  );
}
